import createIcon from '../../createIcon';

/**
 * @component @name ArrowRightAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuMDEgMTFINFYxM0gxNi4wMVYxNkwyMCAxMkwxNi4wMSA4VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowRightAlt = createIcon('ArrowRightAlt', [
  ['path', { d: 'M16.01 11H4V13H16.01V16L20 12L16.01 8V11Z', key: '1b6s42' }],
]);

export default ArrowRightAlt;
